// extracted by mini-css-extract-plugin
export default {"tableDiv":"primetable_tableDiv__Gp2gu","noData":"primetable_noData__xfx+P","loader":"primetable_loader__642w3"};